import { render, staticRenderFns } from "./PracticeView.vue?vue&type=template&id=6b7db16a&"
import script from "./PracticeView.vue?vue&type=script&lang=js&"
export * from "./PracticeView.vue?vue&type=script&lang=js&"
import style0 from "./PracticeView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PracticeView.vue"
export default component.exports